import useIsAdminSeller from '../../../../../../../../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import { useApplicationContext } from '../../../../../../../../../../context/ApplicationContext/ApplicationContext';
import { PaymentMethod } from '../../../../../../../../../../payment-method/payment-method.types';
import {
  getPaymentMethodReleasePolicies,
  getPaymentMethodSuffix,
} from '../../../../../../../../../conditions/orderConditionPaymentMethod.utils';

const useOrderConditionPaymentMethodOption = (paymentMethod: PaymentMethod) => {
  const { isAdminBrand } = useApplicationContext();
  const isAdminSeller = useIsAdminSeller();

  const { visible, hidden } = getPaymentMethodReleasePolicies(paymentMethod);

  return {
    suffix: getPaymentMethodSuffix(paymentMethod),
    isPolicyVisible: isAdminBrand && !isAdminSeller,
    policyLabel: visible?.name ?? '-',
    hiddenPolicyLabels: [...new Set(hidden.map((policy) => policy.name))],
  };
};

export default useOrderConditionPaymentMethodOption;
